<template>
    <div v-observe-visibility="visibilityChanged">

        <!--Creating Customer Offer loading Dialog-->
        <v-dialog
                v-model="getCreatingOfferForInquiry"
                class="loading-dialog"

                persistent
                overlay
                max-width="450px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex xs12>
                        <v-card-title class="headline">Creating customer offer...</v-card-title>
                    </v-flex>
                    <v-flex justify-end>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <!--DELETE Position Decline - Dialog-->
        <v-dialog
                persistent
                v-model="deleteSupplierPositionDeclineDialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Supplier Offer Position Decline?</span>
                </v-card-title>

                <v-card-text>
                    <v-layout v-if="decliningSupplierPosition" row pt-4 pb-4 pr-4 pl-4>
                        <v-flex xs12>
                            <v-card-title class="headline">Deleting supplier offer position decline...</v-card-title>
                        </v-flex>
                        <v-flex justify-end>
                            <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-flex>
                    </v-layout>
                    <v-form v-if="!decliningSupplierPosition" ref="form" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this supplier offer position decline?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat
                           @click.native="cancelDeleteSupplierOfferPositionDeclineDialog()">CANCEL
                    </v-btn>
                    <v-btn color="primary darken-1" flat @click.native="removeSupplierOfferPositionDecline()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!--DELETE Decline - Dialog-->
        <v-dialog
                persistent
                v-model="deleteSupplierDeclineDialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Supplier Offer Decline?</span>
                </v-card-title>

                <v-card-text>
                    <v-layout v-if="decliningSupplier" row pt-4 pb-4 pr-4 pl-4>
                        <v-flex xs12>
                            <v-card-title class="headline">Deleting supplier offer decline...</v-card-title>
                        </v-flex>
                        <v-flex justify-end>
                            <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-flex>
                    </v-layout>
                    <v-form v-if="!decliningSupplier" ref="form" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this supplier offer decline?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat
                           @click.native="cancelDeleteSupplierOfferDeclineDialog()">CANCEL
                    </v-btn>
                    <v-btn color="primary darken-1" flat @click.native="removeSupplierOfferDecline()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Save Supplier Offer - Dialog-->
        <v-dialog v-model="chooseSupplierDialog" persistent fullscreen>
            <v-card>
                <v-toolbar height="90" fixed light color="white">
                    <v-btn @click.native="stepBack()" v-show="this.step !== 1" flat fab small icon>
                        <v-icon>arrow_back_ios</v-icon>
                    </v-btn>
                    <span class="headline">{{currentAddSupplierOfferDialogTitle}}</span>
                    <v-spacer></v-spacer>
                    <span class="headline">{{getSelectedInquiry.project_number}}</span>
                    <v-btn @click.native="stepForward()"
                           v-show="this.step !== 1 && this.step !== 3 &&  selectedSupplierOffer !== null" flat fab small
                           icon>
                        <v-icon>arrow_forward_ios</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text style="height: 100vh">
                    <v-window v-model="step" class="supplierWizard">
                        <v-layout row pt-5>
                            <v-layout row pt-5>
                            </v-layout>
                        </v-layout>
                        <!--TODO - move to component-->
                        <!--Select Supplier-->
                        <v-window-item :value="1" style="min-height: 1000px;">
                            <v-container grid-list-md text-xs-center
                                         v-if="getSupplierOfferLoading">
                                <v-layout row wrap align-center fill-height style="height: 100vh;">
                                    <v-flex xs12>
                                        <v-card flat height="200px">
                                            <v-flex xs12 pa-4>
                                                <v-progress-circular
                                                        :size="60"
                                                        color="primary"
                                                        indeterminate
                                                ></v-progress-circular>
                                            </v-flex>
                                            <v-flex xs12>
                                            <span class="headline">
                                                Loading supplier offers...
                                            </span>
                                            </v-flex>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <v-container grid-list-md text-xs-center
                                         v-else-if="getSupplierOpenDialogState">
                                <v-layout row wrap align-center fill-height style="height: 100vh;">
                                    <v-flex xs12>
                                        <v-card flat height="200px">
                                            <v-flex xs12 pa-4>
                                                <v-progress-circular
                                                        :size="60"
                                                        color="primary"
                                                        indeterminate
                                                ></v-progress-circular>
                                            </v-flex>
                                            <v-flex xs12>
                                            <span class="headline">
                                                Loading suppliers...
                                            </span>
                                            </v-flex>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <div class="listContainer" v-else>
                                <v-list two-line>
                                    <template v-for="(item, index) in this.getSelectedInquiryPosition.suppliers">
                                        <v-list-tile
                                                @click="selectSupplier(item)">
                                            <v-list-tile-content>
                                                <v-list-tile-title>{{item ? item.name : 'unknown...'}}
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-spacer></v-spacer>
                                            <v-chip v-if="isSupplierDeclined(item ? item.id : 'unknown...')" color="red"
                                                    text-color="white">
                                                DECLINED
                                            </v-chip>
                                            <v-chip v-if="hasSupplierOffer(item ? item.id : 'unknown...')" color="success"
                                                    text-color="white">
                                                OFFER
                                            </v-chip>
                                            <v-list-tile-action>
                                                <v-icon>arrow_forward_ios</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        <v-divider></v-divider>
                                    </template>
                                </v-list>
                            </div>
                        </v-window-item>
                        <!--TODO - move to component-->
                        <!--Create Supplier Offer-->
                        <v-window-item :value="2" style="min-height: 1000px;">
                            <v-container grid-list-md text-xs-center
                                         v-if="getSupplierOfferLoading">
                                <v-layout row wrap align-center fill-height style="height:100vh;">
                                    <v-flex xs12>
                                        <v-card flat height="200px">
                                            <v-flex xs12 pa-4>
                                                <v-progress-circular
                                                        :size="60"
                                                        color="primary"
                                                        indeterminate
                                                ></v-progress-circular>
                                            </v-flex>
                                            <v-flex xs12>
                                            <span class="headline">
                                                Save supplier offer...
                                            </span>
                                            </v-flex>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <v-container grid-list-md text-xs-center
                                         v-if="decliningSupplier">

                                <v-card flat height="200px">
                                    <v-layout row wrap align-center fill-height>
                                        <v-flex xs12>
                                            <v-progress-circular
                                                    :size="60"
                                                    color="primary"
                                                    indeterminate
                                            ></v-progress-circular>
                                        </v-flex>
                                        <v-flex xs12>
                                            <span class="headline">
                                                Declining supplier offer...
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-container>

                            <div v-if="!getSupplierOfferLoading && !decliningSupplier">
                                <v-layout v-if="!declineSupplierChecked " row wrap>

                                    <v-flex xs12 md6 pl-4 pa-2>

                                        <v-text-field
                                                label="Offer Number"
                                                v-model="newSupplierOffer.offer_number"
                                                counter
                                                maxlength="255"
                                        ></v-text-field>

                                    </v-flex>

                                    <v-flex xs12 md6 pl-4 pa-2>
                                        <v-autocomplete class="contactPerson"
                                                        label="Contact Person"
                                                        chips
                                                        v-model="newSupplierOffer.suppliers_contacts_id"
                                                        persistent-hint
                                                        :deletable-chips=chipsDeletable
                                                        :items="getSupplierContacts"
                                                        :filter="customContactFilter"
                                                        item-value="id"
                                                        item-text="name"

                                        >

                                            <template slot="selection" slot-scope="data">
                                                <v-chip v-if="data.item.main_contact"
                                                        color="primary"
                                                        :selected="data.selected"
                                                        close
                                                        class="chip--select-multi white--text"
                                                        @input="removeContactPersonItem(data.item)"
                                                >
                                                    {{ data.item.title ? data.item.title : '' }} {{
                                                    data.item.firstname
                                                    }} {{
                                                    data.item.lastname }}
                                                </v-chip>
                                                <v-chip v-else
                                                        :selected="data.selected"
                                                        close
                                                        class="chip--select-multi"
                                                        @input="removeContactPersonItem(data.item)"
                                                >
                                                    {{ data.item.title ? data.item.title : '' }} {{
                                                    data.item.firstname
                                                    }} {{
                                                    data.item.lastname }}
                                                </v-chip>
                                            </template>

                                            <template slot="item" slot-scope="data">
                                                <v-list-tile-content>
                                                    <v-list-tile-title>
                                                        {{ data.item.title ? data.item.title : '' }} {{
                                                        data.item.firstname }} {{
                                                        data.item.lastname }}
                                                    </v-list-tile-title>

                                                    <v-list-tile-sub-title v-if="data.item.main_contact"
                                                    >Main Contact
                                                    </v-list-tile-sub-title>

                                                </v-list-tile-content>
                                            </template>

                                            <template slot="no-data">
                                                <v-layout wrap>
                                                    <v-flex xs12 pl-4 pr-4>
                                                        <v-btn @click.native="openNewSupplierContactDialog()" block
                                                               small flat color="secondary">Create New contact
                                                            <v-icon>add</v-icon>
                                                        </v-btn>
                                                    </v-flex>

                                                </v-layout>
                                            </template>

                                        </v-autocomplete>
                                    </v-flex>

                                    <v-flex xs12 md6 pl-4 pa-2>
                                        <DatetimePicker
                                                locale="de-DE"
                                                landscape
                                                mysql
                                                :width="width = 500"
                                                label="Received At"
                                                v-model="newSupplierOffer.received_at"
                                        >
                                        </DatetimePicker>
                                    </v-flex>

                                    <v-flex xs12 md6 pl-4 pa-2>
                                        <DatetimePicker

                                                locale="de-DE"
                                                landscape
                                                mysql
                                                :width="width = 500"
                                                label="Valid Until"
                                                v-model="newSupplierOffer.valid_until"
                                        >
                                        </DatetimePicker>
                                    </v-flex>

                                    <v-flex xs12 md6 pl-4 pa-2>
                                        <v-autocomplete
                                                :items="termsOfDelivery"
                                                item-text="name"
                                                item-value="id"
                                                label="Term of Delivery"
                                                v-model="newSupplierOffer.terms_of_deliveries_id"
                                                required
                                        ></v-autocomplete>
                                    </v-flex>

                                    <v-flex xs12 md6 pl-4 pa-2>
                                        <v-autocomplete
                                                :items="termsOfPayment"
                                                item-text="name"
                                                item-value="id"
                                                label="Term of Payment"
                                                v-model="newSupplierOffer.terms_of_payments_id"
                                                required
                                        ></v-autocomplete>
                                    </v-flex>

                                    <v-flex xs12 md6 pl-4 pa-2>
                                        <v-autocomplete
                                                clearable
                                                v-model="newSupplierOffer.currencies_id"
                                                :items="getCurrencies"
                                                label="Currency"
                                                item-value="id"
                                                item-text="name"
                                        ></v-autocomplete>

                                    </v-flex>

                                    <v-flex xs12 md6 pl-4 pa-2>

                                        <UploadDocumentPicker
                                                v-model="uploadedDocument"
                                                label="Select PDF"
                                        >
                                        </UploadDocumentPicker>

                                    </v-flex>

                                    <v-flex xs12 md6 pl-4 pa-2>
                                    </v-flex>

                                    <v-flex xs12 md6 pl-4 pa-2>

                                        <v-layout>
                                            <v-spacer></v-spacer>
                                            <DocumentTokenChip
                                                    v-show="newSupplierOffer.documents_id !== 0"
                                                    :documentsId="newSupplierOffer.documents_id"
                                                    :documentFilename="newSupplierOffer.offer_number + '.pdf'"
                                            >
                                            </DocumentTokenChip>
                                        </v-layout>

                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 md6 pl-4>
                                        <v-checkbox
                                                @click.native="showRemoveSupplierDeclineDialog()"
                                                v-model="declineSupplierChecked" color="primary"
                                                label="Decline Supplier"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="declineSupplierChecked" row wrap>
                                    <v-flex xs12 md12 pl-4 pr-4>
                                        <v-textarea
                                                v-model="newSupplierOfferDecline.decline_remark"
                                                auto-grow
                                                rows="1"
                                                label="Decline Supplier Remark"
                                                counter
                                                maxlength="255"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>

                            </div>
                        </v-window-item>
                        <!--TODO - move to component-->
                        <!--Create Supplier Offer Position-->
                        <v-window-item :value="3" style="min-height: 1000px;">
                            <v-flex xs12 v-if="getSupplierOfferPositionLoading && !declineSupplierPositionChecked">
                                <v-container grid-list-md text-xs-center>
                                    <v-layout row wrap align-center fill-height style="height:70vh;">
                                        <v-flex xs12>
                                            <v-card flat height="200px">
                                                <v-flex xs12 pa-4>
                                                    <v-progress-circular
                                                            :size="60"
                                                            color="primary"
                                                            indeterminate
                                                    ></v-progress-circular>
                                                </v-flex>
                                                <v-flex xs12>
                                            <span class="headline">
                                                Loading supplier offer position...
                                            </span>
                                                </v-flex>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>
                            <v-flex xs12 v-else>
                                <v-layout class="" v-if="!declineSupplierPositionChecked" wrap>
                                    <v-flex xs12 md2>
                                        <v-text-field
                                                v-model="getSelectedInquiryPosition.id"
                                                label="Position-ID"
                                                box
                                                readonly
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md2>
                                        <v-text-field
                                                v-model="getSelectedInquiryPosition.internal_number"
                                                label="Internal Number"
                                                box
                                                readonly
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md2>
                                        <v-text-field
                                                v-model="getSelectedInquiryPosition.manufacturer.name"
                                                label="Manufacturer"
                                                box
                                                readonly
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md2>
                                        <v-text-field
                                                v-model="getSelectedInquiryPosition.item_number"
                                                label="Item Number"
                                                box
                                                readonly
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md2>
                                        <v-text-field
                                                v-model="getSelectedInquiryPosition.quantity"
                                                label="Quantity"
                                                box
                                                readonly
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md2>
                                        <v-text-field
                                                v-model="getSelectedInquiryPosition.unit.code"
                                                label="Unit"
                                                box
                                                readonly
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md8 offset-md4>
                                        <v-textarea class="customerDesc"
                                                    v-model="getSelectedInquiryPosition.customer_description"
                                                    rows="4"
                                                    label="Customer Description"
                                                    box
                                                    readonly
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>

                                <!--                        <v-layout class="layoutWrapHeight" wrap v-if="!declineSupplierPositionChecked">

                                                        </v-layout>-->

                                <v-container grid-list-md>

                                    <v-layout v-if="!declineSupplierPositionChecked" wrap>

                                        <v-flex xs12 pb-3>
                                            <v-subheader>Position values</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md3 pl-4 pa-2>
                                            <v-text-field
                                                    label="Item-Number"
                                                    v-model="getSelectedSupplierOfferPosition.product.reference"
                                                    counter
                                                    maxlength="255"
                                                    :loading="loading"
                                            ></v-text-field>
                                            <!--
                                               TODO - add searchable and createable
                                               <v-combobox
                                                                                                :loading="loading"
                                                                                                :items="getProductsSearchedByReference"

                                                                                                label="Search-Item Number"
                                                                                                v-model="getSelectedSupplierOfferPosition.product"
                                                                                                item-text="reference"
                                                                                                hide-no-data
                                                                                                hide-details
                                                                                        ></v-combobox>-->

                                        </v-flex>

                                        <v-flex xs12 md1 pl-4 pa-2>
                                            <v-text-field
                                                    label="Quantity"
                                                    v-model="getSelectedSupplierOfferPosition.quantity"
                                                    type="number"
                                                    min="1"

                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md2 pl-4 pa-2>
                                            <v-autocomplete
                                                    clearable
                                                    :items="getUnits"
                                                    v-model="getSelectedSupplierOfferPosition.units_id"
                                                    label="Unit"
                                                    item-value="id"
                                                    item-text="name"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md3 pl-4 pa-2>

                                            <v-text-field
                                                    id="supplierOfferPositionPrice"
                                                    :suffix="getSupplierOfferCurrency"
                                                    label="Unit-Price"
                                                    v-model.lazy="getSupplierOfferPositionPrice"
                                                    v-money="money"
                                            >
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md3 pl-4 pa-2>

                                            <v-text-field
                                                    :suffix="getSupplierOfferCurrency"
                                                    label="Total-Price"
                                                    v-model="totalSupplierOfferPositionPrice"
                                                    readonly
                                            >

                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md4 pl-4 pa-2>
                                            <v-text-field
                                                    label="HS-Code"
                                                    v-model="getSelectedSupplierOfferPosition.product.hscode"
                                                    counter
                                                    maxlength="255"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md8 pl-4 pa-2>
                                            <v-textarea
                                                    auto-grow
                                                    rows="1"
                                                    label="Product Description"
                                                    v-model="getSelectedSupplierOfferPosition.product.product_description.description"
                                                    counter
                                                    maxlength="500"
                                            ></v-textarea>
                                        </v-flex>

                                        <v-flex xs12 md4 pl-4 pa-2>
                                            <v-text-field
                                                    suffix="kg"
                                                    label="Net Weight"
                                                    v-model="getSelectedSupplierOfferPosition.product.weight"
                                                    type="number"
                                                    step=".01"
                                                    min="0"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex sm12 md4 pl-4 pa-2>
                                            <v-autocomplete
                                                    clearable
                                                    :items="getManufacturers"
                                                    label="Manufacturer"
                                                    v-model="getSelectedSupplierOfferPosition.product.manufacturers_id"
                                                    item-value="id"
                                                    item-text="name"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md2 pl-4 pa-2>
                                            <v-text-field
                                                    label="Delivery Time"
                                                    v-model="getSelectedSupplierOfferPosition.delivery_time.value"
                                                    type="number"
                                                    step=".01"
                                                    min="0"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md2 pl-4 pa-2>
                                            <v-autocomplete
                                                    clearable
                                                    v-model="getSelectedSupplierOfferPosition.delivery_time.delivery_times_types_id"
                                                    :items="getDeliveryTimeTypes"
                                                    label="Type"
                                                    item-value="id"
                                                    item-text="name"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md4 pl-4 pa-2>
                                            <v-textarea
                                                    auto-grow
                                                    rows="1"
                                                    label="Offer Position Remark"
                                                    v-model="getSelectedSupplierOfferPosition.remark"
                                                    counter
                                                    maxlength="500"
                                            ></v-textarea>
                                        </v-flex>

                                        <v-flex xs12 pt-3>
                                            <v-layout wrap>
                                                <v-subheader>Discounts</v-subheader>
                                                <v-spacer></v-spacer>
                                                <v-btn icon color="secondary darken-1"
                                                       @click.native="addSupplierOfferPositionDiscount()">
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12 pb-3>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 pl-4 pa-2>
                                            <v-layout wrap>
                                                <template
                                                        v-for="(item, index) in getSelectedSupplierOfferPosition.discounts">
                                                    <v-card-text>
                                                        <v-layout wrap pb-3>
                                                            <v-flex xs12 md2>

                                                                <v-text-field
                                                                        suffix="%"
                                                                        label="Discount"
                                                                        v-model="item.value"
                                                                        type="number"
                                                                        step=".01"
                                                                        min="0"
                                                                        max="100"
                                                                ></v-text-field>

                                                            </v-flex>

                                                            <v-flex xs12 md6>
                                                                <v-textarea
                                                                        auto-grow
                                                                        rows="1"
                                                                        label="Discount description"
                                                                        v-model="item.description"
                                                                        counter
                                                                        maxlength="255"
                                                                ></v-textarea>
                                                            </v-flex>

                                                            <v-flex xs8 md3>
                                                                <v-autocomplete
                                                                        clearable
                                                                        v-model="item.type"
                                                                        :items="discountTypes"
                                                                        label="Type"
                                                                ></v-autocomplete>

                                                            </v-flex>

                                                            <v-spacer></v-spacer>
                                                            <v-btn :loading="getRemovingSupplierOfferPositionDiscount(index)"
                                                                   icon ripple
                                                                   @click.native="removeSupplierOfferPositionDiscount(index)">
                                                                <v-icon color="red lighten-1">delete</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                        <v-divider></v-divider>
                                                    </v-card-text>
                                                </template>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout wrap>
                                        <v-flex xs12 pb-3>
                                            <v-subheader>Decline</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>
                                        <v-layout row wrap>
                                            <v-flex xs12 md6 pl-4>
                                                <v-checkbox
                                                        @click.native="showRemoveSupplierPositionDeclineDialog()"
                                                        v-model="declineSupplierPositionChecked" color="primary"
                                                        label="Decline Supplier Position"></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-if="declineSupplierPositionChecked" row wrap>
                                            <v-flex xs12 md12 pl-4 pr-4>
                                                <v-textarea
                                                        v-model="newSupplierOfferPositionDecline.decline_remark"
                                                        auto-grow
                                                        rows="1"
                                                        label="Decline Supplier Position Remark"
                                                        counter
                                                        maxlength="255"
                                                ></v-textarea>
                                            </v-flex>
                                        </v-layout>

                                    </v-layout>

                                </v-container>
                            </v-flex>
                        </v-window-item>

                        <v-layout row pb-5>
                            <v-layout row pb-3>
                            </v-layout>
                        </v-layout>

                    </v-window>

                </v-card-text>

                <v-bottom-nav
                        :value="true"
                        absolute
                        color="white"
                >
                    <!--                   <v-spacer v-if="step === 1"></v-spacer>-->
                    <v-btn color="primary darken-1" flat @click.native="cancelEnterSupplierOfferDialog()">CANCEL
                    </v-btn>
                    <v-spacer v-if="step > 1"></v-spacer>
                    <v-spacer v-if="step > 1"></v-spacer>
                    <v-btn flat
                           :disabled="getSupplierOfferLoading"
                           :loading="getSupplierOfferLoading"
                           v-if="step === 2 && !declineSupplierChecked" color="secondary darken-1"
                           @click.native="saveSupplierOffer()">SAVE OFFER
                    </v-btn>
                    <v-btn flat
                           :disabled="getSupplierOfferLoading"
                           :loading="getSupplierOfferLoading"
                           v-if="step === 2 && declineSupplierChecked" color="secondary darken-1"
                           @click.native="saveSupplierOfferDecline()">DECLINE SUPPLIER
                    </v-btn>
                    <v-btn flat :loading="getSupplierOfferPositionSaving"
                           v-if="step === 3 && !declineSupplierPositionChecked" color="secondary darken-1"
                           @click.native="saveSupplierOfferPosition()">SAVE
                        POSITION
                    </v-btn>
                    <v-btn flat :loading="decliningSupplierPosition" v-if="step === 3 && declineSupplierPositionChecked"
                           color="secondary darken-1"
                           @click.native="saveSupplierOfferPositionDecline()">DECLINE
                        POSITION
                    </v-btn>
                </v-bottom-nav>
            </v-card>
        </v-dialog>

        <v-layout id="table-container" row ml-4 mr-4 mt-4>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        Inquriry Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            v-model="selected"
                            :headers="headers"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0"
                            select-all
                            :loading="loading"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>

                        <template slot="items" slot-scope="props">
                            <tr @dblclick="openDialog(props.item.id)">

                                <td>
                                    <v-checkbox
                                            v-model="props.selected"
                                            color="secondary"
                                            hide-details
                                    ></v-checkbox>
                                </td>
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{ props.item.internal_number }}</td>
                                <td class="text-xs-left">{{ props.item.manufacturer ? props.item.manufacturer.name === null ? 'no brand name' : props.item.manufacturer.name : 'no manufacturer' }}</td>
                                <td class="text-xs-left">{{ props.item.item_number }}</td>
                                <td class="text-xs-left">{{ props.item.quantity }}</td>
                                <td class="text-xs-left">{{ props.item.unit.code }}</td>
                                <td class="text-xs-left">
                                    <v-progress-linear
                                            slot="progress"
                                            :value="calculateProgress(props.item.id)"
                                            :color="color(props.item.id)"
                                            height="7"
                                    ></v-progress-linear>
                                </td>

                                <td class="text-xs-center">
                                    {{ props.item.supplier_offers.length }} / {{ props.item.suppliers.length }}
                                </td>

                                <td class="text-xs-center">
                                    {{ props.item.supplier_offers_positions.length }} / {{ props.item.suppliers.length
                                    }}
                                </td>

                                <td class="text-xs-left">{{ props.item.inquiries_positions_status ? props.item.inquiries_positions_status.name : 'unknown...' }}</td>

                                <td class="text-xs-center" @click="openDialog(props.item.id)">
                                    <v-btn small color="primary" flat>Supplier Offer
                                        <v-icon right>arrow_forward_ios</v-icon>
                                    </v-btn>
                                </td>

                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>

        <v-layout mt-5 pb-3 mr-3 row justify-end>
            <v-btn mt-5 dark color="secondary" @click.native="createCustomerOffer()">
                Create Customer Offer
                <v-icon class="white--text" right>arrow_forward</v-icon>
            </v-btn>
        </v-layout>

        <addSupplierDialog></addSupplierDialog>

    </div>

</template>

<script>
import {
  Settings,
  Inquiry,
  InquiryPosition,
  ManufacturersSettings,
  ContactPersonSettings,
  SupplierOffers,
  SupplierOfferDeclines,
  SupplierOfferPositionDeclines,
  SupplierOfferPositions,
  ProductSettings,
  Offer
} from '../../../store/namespace-helper'

import addSupplierDialog from '../../Settings/Suppliers/AddSupplierDialog.vue'
import DatetimePicker from '../../Shared/DatetimePicker.vue'
import UploadDocumentPicker from '../../Shared/UploadDocumentPicker.vue'
import DocumentTokenChip from '../../Shared/DocumentTokenChip.vue'
import {VMoney} from 'v-money'

import _ from 'lodash'

export default {

  components: {
    DatetimePicker,
    addSupplierDialog,
    UploadDocumentPicker,
    DocumentTokenChip
  },
  name: 'SupplierOffersInquiryPositions',
  data () {
    return {
      isVisible: false,
      hide: true,
      all: false,
      step: 1,
      stepBackClicked: false,
      selected: [],
      activeTab: 0,
      headers: [
        {text: 'Position-ID', value: 'id'},
        {text: 'Internal Number', value: 'internal_number'},
        {text: 'Manufacturer', value: 'manufacturers_id'},
        {text: 'Item Number', value: 'item_number'},
        {text: 'Quantity', value: 'quantity'},
        {text: 'Unit', value: 'unit_id', sortable: false},
        {text: 'Progress', value: 'progress', sortable: false},
        {text: 'Offers', value: 'supplier_offers'},
        {text: 'Offers Positions', value: 'supplier_offers_positions'},
        {text: 'Status', value: 'inquiries_position_status_id'},
        {text: 'Action', value: 'action', sortable: false, align: 'center'}
      ],
      pagination: {},
      search: '',
      total: 0,
      onDismissed: false,
      rowsPageItems: [{'text': 'All', 'value': -1}],
      selectedSuppliers: null,
      chipsDeletable: true,
      chooseSupplierDialog: false,
      deleteDialog: false,
      deleteChecked: false,
      deleteFormValidation: false,
      supplierRequestsWillBeCreated: false,
      supplierRequestsWillBeCreatedError: false,
      selectedSupplier: null,
      declineSupplierChecked: false,
      declineSupplierPositionChecked: false,
      decliningSupplier: false,
      decliningSupplierPosition: false,
      rules: {
        required: value => !!value || 'Required.',
        descriptionCounter: value => value.length <= 500 || 'Max 500 characters',
        numberCounter: value => value.length <= 255 || 'Max 255 characters'
      },
      creatingRequestsErrorMsg: '',
      newSupplierOffer: {
        documents_id: 0
      },
      newSupplierOfferDeclineTemplate: {
        id: 0,
        inquiries_id: 0,
        decline_remark: ''
      },
      newSupplierOfferPositionDeclineTemplate: {
        id: 0,
        inquiries_id: 0,
        decline_remark: ''
      },
      newSupplierOfferDecline: this.newSupplierOfferDeclineTemplate,
      newSupplierOfferPositionDecline: {
        id: 0,
        inquiries_id: 0,
        inquiries_positions_id: 0,
        suppliers_id: 0,
        decline_remark: ''
      },
      dialog: false,
      customContactFilter (item, queryText, itemText) {
        const isMatch = (test, query) => {
          return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
        }
        const query = queryText || ''
        const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
        const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
        console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
        return rc
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true /* doesn't work with directive */
      },
      discountTypes: ['percent'],
      totalSupplierOfferPositionPrice: '0,00',
      indexToDelete: 0,
      deleteSupplierDeclineDialog: false,
      deleteSupplierPositionDeclineDialog: false,
      searchReference: '',
      selectedProduct: {},
      supplierOpenDialogState: false,
      uploadedDocument: null
    }
  },
  mounted () {

  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('tab visible, load data')
          this.$store.dispatch(InquiryPosition.actions.resetAllInquiriesPositions)
          this.loadItems()
          this.loadManufacturers()
          this.loadUnits()
          this.loadCurrencies()
          this.loadDeliveryTimeTypes()
          this.loadTermsOfPayments()
          this.loadTermsOfDeliveries()
          this.loadSuppliersOfferDeclines()
        } else {
          this.selected = []
        }
      }
    },
    loadItems: function () {
      const {sortBy, descending, page, rowsPerPage} = this.pagination
      const query = {
        id: this.getSelectedInquiry.id,
        sortBy: sortBy || 'id',
        descending: descending ? 'desc' : 'asc',
        page: page || 1,
        limit: rowsPerPage !== -1 ? rowsPerPage : 0,
        search: this.search ? this.search : ''
      }
      this.$store.dispatch(InquiryPosition.actions.loadAllInquiriesPositions, query)
    },
    searchProducts: function () {
      this.$store.dispatch(ProductSettings.actions.searchProductsByReference, this.searchReference)
    },
    loadManufacturers () {
      this.$store.dispatch(ManufacturersSettings.actions.loadAllManufacturers)
    },
    loadUnits () {
      this.$store.dispatch(Settings.actions.loadAllUnits)
    },
    loadCurrencies () {
      this.$store.dispatch(Settings.actions.loadAllCurrencies)
    },
    loadDeliveryTimeTypes () {
      this.$store.dispatch(Settings.actions.loadAllDeliveryTimeTypes)
    },
    loadSuppliers (manufacturersId) {
      console.log('loading all suppliers for manufacturers_id: ' + manufacturersId)
      this.$store.dispatch(Settings.actions.loadSuppliersByManufacturers, manufacturersId)
    },
    loadTermsOfPayments () {
      this.$store.dispatch(Settings.actions.loadTermsOfPayments)
    },
    loadTermsOfDeliveries () {
      this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
    },
    loadSuppliersOfferDeclines () {
      console.log('loading all suppliers offer declines for inquiry_id: ' + this.getSelectedInquiry.id)
      this.$store.dispatch(SupplierOfferDeclines.actions.loadSupplierOfferDeclinesByInquiryID, this.getSelectedInquiry).then(response => {
        this.stepBack()
        this.decliningSupplier = false
        this.declineSupplierChecked = false
        this.newSupplierOfferDecline = {
          id: 0,
          inquiries_id: 0,
          decline_remark: ''
        }
      })
    },
    loadSuppliersOfferPositionDeclines () {
      let params = {
        inquiries_positions_id: this.getSelectedInquiryPosition.id,
        suppliers_id: this.selectedSupplier.id
      }
      this.$store.dispatch(SupplierOfferPositionDeclines.actions.loadSupplierOfferPositionDeclinesByInquiryPositionID, params).then(response => {
        if (response.data.data.length > 0) {
          this.declineSupplierPositionChecked = true
          this.newSupplierOfferPositionDecline = response.data.data[0]
        } else {
          this.declineSupplierPositionChecked = false
          this.newSupplierOfferPositionDecline = this.newSupplierOfferPositionDeclineTemplate
        }
        this.decliningSupplierPosition = false
      })
    },
    createCustomerOffer () {
      let selectedArr = []
      this.selected.forEach(item => {
        selectedArr.push(item.id)
      })
      this.$store.dispatch(Offer.actions.createForInquiry, {
        inquiries_id: this.getSelectedInquiry.id,
        selected_items: selectedArr
      }).then(response => {
        selectedArr = []
        this.selected = []
        this.loadItems()
      }).catch(err => {
        console.log(JSON.stringify(err))
        selectedArr = []
        this.selected = []
      })
    },
    saveSupplierOffer () {
      if (typeof this.newSupplierOffer.id === 'undefined') {
        this.newSupplierOffer.id = 0
      }
      this.newSupplierOffer.suppliers_id = this.selectedSupplier.id
      this.newSupplierOffer.inquiries_id = this.getSelectedInquiry.id
      this.$store.dispatch(SupplierOffers.actions.saveSupplierOffer, this.newSupplierOffer)
    },
    saveSupplierOfferDecline () {
      this.newSupplierOfferDecline.inquiries_id = this.getSelectedInquiry.id
      this.newSupplierOfferDecline.suppliers_id = this.selectedSupplier.id
      this.decliningSupplier = true
      this.$store.dispatch(SupplierOfferDeclines.actions.saveSupplierOfferDeclines, this.newSupplierOfferDecline).then(response => {
        this.loadSuppliersOfferDeclines()
      })
    },
    saveSupplierOfferPositionDecline () {
      this.newSupplierOfferPositionDecline.inquiries_id = this.getSelectedInquiry.id
      this.newSupplierOfferPositionDecline.suppliers_id = this.selectedSupplier.id
      this.newSupplierOfferPositionDecline.inquiries_positions_id = this.getSelectedInquiryPosition.id
      this.decliningSupplierPosition = true
      this.$store.dispatch(SupplierOfferPositionDeclines.actions.saveSupplierOfferPositionDeclines, this.newSupplierOfferPositionDecline).then(response => {
        this.loadSuppliersOfferPositionDeclines()
        this.step = 1
      })
    },
    saveSupplierOfferPosition () {
      if (this.getSelectedSupplierOfferPosition.id === 0) {
        this.getSelectedSupplierOfferPosition.suppliers_offers_id = this.selectedSupplierOffer.id
        this.getSelectedSupplierOfferPosition.inquiries_positions_id = this.getSelectedInquiryPosition.id
      }
      this.$store.dispatch(SupplierOfferPositions.actions.saveSupplierOfferPosition, this.getSelectedSupplierOfferPosition).then(response => {
        this.loadSupplierOfferPositionBySupplierOfferAndInquiryPositionID(this.selectedSupplierOffer.id)
      })
    },
    openDialog (val) {
      if (val !== null) {
        let item = this.getItems.find(x => x.id === val)
        this.$store.dispatch(InquiryPosition.actions.setSelectedInquiryPosition, item)
      }
      this.chooseSupplierDialog = true
      this.supplierOpenDialogState = true
      this.setOpenDialogState(false)
    },
    setOpenDialogState (val) {
      setTimeout((val) => {
        this.supplierOpenDialogState = val
      }, 850)
    },
    isSupplierDeclined (val) {
      if (val !== null) {
        if (this.getSupplierOfferDeclines !== null) {
          let item = this.getSupplierOfferDeclines.find(x => x.suppliers_id === val)
          if (item !== null) {
            if (typeof item !== 'undefined') {
              return true
            }
          }
          return false
        }
      }
      return false
    },
    hasSupplierOffer (val) {
      if (val !== null) {
        if (this.getSelectedInquiryPosition.supplier_offers.length > 0) {
          let item = this.getSelectedInquiryPosition.supplier_offers.find(x => x.suppliers_id === val)
          if (typeof item !== 'undefined') {
            return true
          }
        }
        return false
      }
    },
    setDeclinedSupplier (val) {
      if (val !== null) {
        if (this.getSupplierOfferDeclines !== null) {
          let item = this.getSupplierOfferDeclines.find(x => x.suppliers_id === val)
          if (item !== null) {
            if (typeof item !== 'undefined') {
              this.declineSupplierChecked = true
              this.newSupplierOfferDecline = item
              return true
            }
          }
          return false
        }
      }
      return false
    },
    selectSupplier (val) {
      this.$store.dispatch(ContactPersonSettings.actions.loadContactPersonsBySupplierId, val.id)
      this.selectedSupplier = val
      this.loadSupplierOfferByInquiryAndSupplierID(val.id)

      this.stepBackClicked = false
    },
    loadSupplierOfferByInquiryAndSupplierID (supplierID) {
      this.$store.dispatch(SupplierOffers.actions.loadSupplierOfferByInquiryAndSupplierID, {
        supplier_id: supplierID,
        inquiry_id: this.getSelectedInquiry.id
      })
    },
    loadSupplierOfferPositionBySupplierOfferAndInquiryPositionID (supplierOffersID) {
      this.loadSuppliersOfferPositionDeclines()
      this.$store.dispatch(SupplierOfferPositions.actions.loadSupplierOfferPositionBySupplierOfferAndInquiryPositionID, {
        suppliers_offers_id: supplierOffersID,
        inquiries_positions_id: this.getSelectedInquiryPosition.id
      }).then(response => {
        if (!response.data.data.length > 0) {
          let tmpPosition = _.cloneDeep(this.getSelectedInquiryPosition)

          let product = null

          let query = {
            reference: tmpPosition.item_number
          }

          this.$store.dispatch(ProductSettings.actions.loadProductByReference, query).then(response => {
            if (response.length > 0) {
              product = response[0]

              tmpPosition.id = 0
              tmpPosition.unit_price = '0.00'
              tmpPosition.product = product
              tmpPosition.delivery_time = {}
              tmpPosition.discounts = []

              this.$store.dispatch(SupplierOfferPositions.actions.setSupplierOfferPosition, [tmpPosition])
            } else {
              tmpPosition.id = 0
              tmpPosition.unit_price = '0.00'
              tmpPosition.product = {}
              tmpPosition.product.id = 0
              tmpPosition.product.manufacturers_id = tmpPosition.manufacturers_id
              tmpPosition.product.product_description = {}
              tmpPosition.product.product_description.locale = 'en'
              tmpPosition.product.product_description.description = tmpPosition.supplier_description
              tmpPosition.product.reference = tmpPosition.item_number
              tmpPosition.delivery_time = {}
              tmpPosition.discounts = []

              this.$store.dispatch(SupplierOfferPositions.actions.setSupplierOfferPosition, [tmpPosition])
            }
          })
        } else {
          let element = document.getElementById('supplierOfferPositionPrice')
          let event = new Event('input')
          if (typeof element !== 'undefined' && element !== null) {
            element.value = ''
            element.dispatchEvent(event)
            element.value = new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format(this.getSelectedSupplierOfferPosition.unit_price)
            element.dispatchEvent(event)
          }
        }
      })
    },
    deleteInquiryPositionDialog (item) {
      this.editInquiryPositionData = _.cloneDeep(item)
      this.deleteDialog = true
    },
    cancelEnterSupplierOfferDialog () {
      let element = document.getElementById('supplierOfferPositionPrice')
      let event = new Event('input')
      if (typeof element !== 'undefined' && element !== null) {
        element.value = '0,00'
        element.dispatchEvent(event)
      }
      this.chooseSupplierDialog = false
      this.newSupplierOffer = {}
      this.step = 1
      this.loadSuppliersOfferDeclines()
      this.declineSupplierPositionChecked = false
      this.supplierOpenDialogState = false
      this.loadItems()
    },
    editInquiryPosition (item) {
      this.editInquiryPositionData = _.cloneDeep(item)
      this.editDialog = true
    },
    throttledLoadItems: _.debounce(function () {
      this.loadItems()
    }, 450),
    throttledLoadProducts: _.debounce(function () {
      this.searchProducts()
    }, 450),
    removeContactPersonItem () {
      this.newSupplierOffer.suppliers_contacts_id = 0
    },
    stepBack () {
      this.stepBackClicked = true
      this.step--
    },
    stepForward () {
      this.stepBackClicked = false
      if (this.isSupplierDeclined(this.selectedSupplier.id)) {
        if (this.step >= 2) {
          return
        }
        this.step++
      }
      this.step++
    },
    addSupplierOfferPositionDiscount () {
      this.getSelectedSupplierOfferPosition.discounts.push({
        id: 0,
        suppliers_offers_position_id: 0,
        value: 0.00,
        type: 'percent'
      })
    },
    removeSupplierOfferPositionDiscount (index) {
      this.indexToDelete = index
      let id = this.getSelectedSupplierOfferPosition.discounts[index].id

      if (id === 0) {
        this.getSelectedSupplierOfferPosition.discounts.splice(index, 1)
      } else {
        this.$store.dispatch(SupplierOfferPositions.actions.removeSupplierOfferPositionDiscount, id).then(response => {
          this.getSelectedSupplierOfferPosition.discounts.splice(index, 1)
        })
      }
    },
    calculateTotalSupplierOfferPositionPrice () {
      if (this.getSelectedSupplierOfferPosition.unit_price !== 0 && this.getSelectedSupplierOfferPosition.quantity !== 0 && typeof this.getSelectedSupplierOfferPosition.quantity !== 'undefined') {
        let tempUnitPrice = this.getSelectedSupplierOfferPosition.unit_price
        this.getSelectedSupplierOfferPosition.discounts.forEach(function (item) {
          if (item.type === 'percent') {
            tempUnitPrice -= (tempUnitPrice * (item.value / 100))
          }
        })
        this.totalSupplierOfferPositionPrice = new Intl.NumberFormat('de-DE', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2

        }).format(tempUnitPrice * this.getSelectedSupplierOfferPosition.quantity)
      }
    },
    getRemovingSupplierOfferPositionDiscount (val) {
      if (this.indexToDelete === val) {
        return this.$store.getters[SupplierOfferPositions.getters.getRemovingSupplierOfferPositionDiscount]
      }
    },
    showRemoveSupplierPositionDeclineDialog () {
      if (!this.declineSupplierPositionChecked) {
        this.deleteSupplierPositionDeclineDialog = true
      }
    },
    showRemoveSupplierDeclineDialog () {
      if (!this.declineSupplierChecked) {
        this.deleteSupplierDeclineDialog = true
      }
    },
    cancelDeleteSupplierOfferPositionDeclineDialog () {
      this.deleteSupplierPositionDeclineDialog = false
      this.declineSupplierPositionChecked = true
    },
    cancelDeleteSupplierOfferDeclineDialog () {
      this.deleteSupplierDeclineDialog = false
      this.declineSupplierChecked = true
    },
    removeSupplierOfferPositionDecline () {
      if (this.$refs.form.validate()) {
        if (this.newSupplierOfferPositionDecline.id !== 0) {
          this.decliningSupplierPosition = true
          this.$store.dispatch(SupplierOfferPositionDeclines.actions.removeSupplierOfferPositionDecline, this.newSupplierOfferPositionDecline.id).then(response => {
            this.newSupplierOfferPositionDecline = this.newSupplierOfferPositionDeclineTemplate
            this.loadSupplierOfferPositionBySupplierOfferAndInquiryPositionID(this.selectedSupplierOffer.id)
            this.deleteSupplierPositionDeclineDialog = false
          }).catch(error => {
            if (error !== null) {
              this.decliningSupplierPosition = false
              this.declineSupplierPositionChecked = true
              this.deleteSupplierPositionDeclineDialog = false
            }
          })
        } else {
          this.newSupplierOfferPositionDecline = this.newSupplierOfferPositionDeclineTemplate
          this.declineSupplierPositionChecked = false
          this.deleteSupplierPositionDeclineDialog = false
        }
      }
    },
    removeSupplierOfferDecline () {
      if (this.$refs.form.validate()) {
        if (this.newSupplierOfferDecline.id !== 0) {
          this.decliningSupplier = true
          this.$store.dispatch(SupplierOfferDeclines.actions.removeSupplierOfferDecline, this.newSupplierOfferDecline.id).then(response => {
            this.newSupplierOfferDecline = this.newSupplierOfferDeclineTemplate
            this.loadSuppliersOfferDeclines()
            this.deleteSupplierDeclineDialog = false
          }).catch(error => {
            if (error !== null) {
              this.decliningSupplier = false
              this.declineSupplierChecked = true
              this.deleteSupplierDeclineDialog = false
            }
          })
        } else {
          this.newSupplierOfferDecline = this.newSupplierOfferDeclineTemplate
          this.declineSupplierChecked = false
          this.deleteSupplierDeclineDialog = false
        }
      }
    },
    openNewSupplierContactDialog () {
      this.$store.dispatch(Settings.actions.setSelectedSupplier, this.selectedSupplier)
      this.$store.dispatch(Settings.actions.openCloseNewSupplierDialog)
    },
    calculateProgress (val) {
      if (val !== null) {
        let item = this.getItems.find(x => x.id === val)
        /*            console.log('position: id:  ' + val + ' progress: ' + (100 / item.suppliers.length) * item.supplier_offers.length) */
        return (100 / item.suppliers.length) * item.supplier_offers_positions.length
      } else {
        return 0
      }
    },
    color (val) {
      return ['error', 'warning', 'success'][Math.floor(this.calculateProgress(val) / 40)]
    }
  },
  computed: {
    getItems () {
      return this.$store.getters[InquiryPosition.getters.allInquiriesPositions]
    },
    getSuppliers () {
      return this.$store.getters[Settings.getters.getAllSuppliers]
    },
    getSupplierContacts () {
      this.total = this.$store.getters[InquiryPosition.getters.inquiriesPositions].length
      return this.$store.getters[ContactPersonSettings.getters.getContactPersonsForSupplierId]
    },
    getSelectedInquiry () {
      return this.$store.getters[Inquiry.getters.getSelectedInquiry]
    },
    getSelectedInquiryPosition () {
      return this.$store.getters[InquiryPosition.getters.getSelectedInquiryPosition]
    },
    getSupplierOfferDeclines () {
      return this.$store.getters[SupplierOfferDeclines.getters.getSupplierOfferDeclines]
    },
    getManufacturers () {
      return this.$store.getters[ManufacturersSettings.getters.getAllManufacturers]
    },
    getProductsSearchedByReference () {
      return this.$store.getters[ProductSettings.getters.getAllProducts]
    },
    getUnits () {
      return this.$store.getters[Settings.getters.getAllUnits]
    },
    getCurrencies () {
      return this.$store.getters[Settings.getters.getAllCurrencies]
    },
    getDeliveryTimeTypes () {
      return this.$store.getters[Settings.getters.getAllDeliveryTimeTypes]
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    descriptionRules () {
      return [this.rules.descriptionCounter]
    },
    numberRules () {
      return [this.rules.numberCounter]
    },
    currentAddSupplierOfferDialogTitle () {
      try {
        switch (this.step) {
          case 1:
            return 'Choose Supplier for Position: ' + this.getSelectedInquiryPosition.id
          case 2:
            if (typeof this.newSupplierOffer.id !== 'undefined') {
              if (this.isSupplierDeclined(this.selectedSupplier.id)) {
                return 'Update Decline for ' + this.selectedSupplier.name + ' - Position: ' + this.getSelectedInquiryPosition.id
              }
              return 'Update Offer for ' + this.selectedSupplier.name + ' - Position: ' + this.getSelectedInquiryPosition.id
            } else {
              if (this.isSupplierDeclined(this.selectedSupplier.id)) {
                return 'Update Decline for ' + this.selectedSupplier.name + ' - Position: ' + this.getSelectedInquiryPosition.id
              }
              return 'Enter New Offer for ' + this.selectedSupplier.name + ' - Position: ' + this.getSelectedInquiryPosition.id
            }
          case 3:
            return 'Enter Offer Position for ' + this.selectedSupplier.name + ' - Position: ' + this.getSelectedInquiryPosition.id
          case 4:
            return 'Finished'
          default:
            return ''
        }
      } catch (e) {
        console.error(e, 'currentAddSupplierOfferDialogTitle')
      }
    },
    termsOfPayment () {
      return this.$store.getters[Settings.getters.getTermsOfPayments]
    },
    termsOfDelivery () {
      return this.$store.getters[Settings.getters.getTermsOfDeliveries]
    },
    getNetworkError () {
      return this.$store.getters[Settings.getters.getNetworkError]
    },
    selectedSupplierOffer () {
      let supplierOffer = this.$store.getters[SupplierOffers.getters.getSupplierOffer]
      if (typeof supplierOffer !== 'undefined' && supplierOffer != null && supplierOffer.length != null && supplierOffer.length > 0) {
        return supplierOffer[0]
      } else {
        return null
      }
    },
    getSupplierOfferLoading () {
      return this.$store.getters[SupplierOffers.getters.getLoadingSupplierOffer]
    },
    getSupplierOfferPositionLoading () {
      return this.$store.getters[SupplierOfferPositions.getters.getLoadingSupplierOfferPosition]
    },
    getSupplierOfferPositionSaving () {
      return this.$store.getters[SupplierOfferPositions.getters.getSavingSupplierOfferPosition]
    },
    getSupplierOfferCurrency () {
      if (this.selectedSupplierOffer !== null) {
        let currency = this.getCurrencies.find(x => x.id === this.selectedSupplierOffer.currencies_id)
        if (currency !== null && typeof currency !== 'undefined') {
          return currency.name
        }
      }
      return ''
    },
    getSelectedSupplierOfferPosition () {
      return this.$store.getters[SupplierOfferPositions.getters.getSupplierOfferPosition][0]
    },
    getSupplierOfferPositionPrice: {
      set (val) {
        this.$store.dispatch(SupplierOfferPositions.actions.setSupplierOfferPositionPrice, val)
      },
      get () {
        return this.$store.getters[SupplierOfferPositions.getters.getSupplierOfferPositionPrice]
      }
    },
    getSupplierDialogState () {
      return this.$store.getters[Settings.getters.getOpenNewSupplierDialogState]
    },
    getCreatingOfferForInquiry () {
      return this.$store.getters[Offer.getters.getCreatingOfferForInquiry]
    },
    getSupplierOpenDialogState () {
      return this.supplierOpenDialogState
    }

  },
  watch: {
    pagination: {
      handler () {
        this.loadItems()
      },
      deep: true
    },
    search: {
      handler (val) {
        this.throttledLoadItems()
      },
      deep: true
    },
    /*        selected: {
                      handler (val) {
                        console.log('selectedPositions: ' + JSON.stringify(val))
                      },
                      deep: true
                    }, */
    uploadedDocument: {
      handler (val) {
        this.newSupplierOffer.documents_id = val.id
        console.log('uploadedDocuments id: ' + JSON.stringify(val))
      },
      deep: true
    },
    searchReference: {
      handler (val) {
        this.throttledLoadProducts()
      },
      deep: true
    },
    selectedProduct: {
      handler (val) {
        console.log('selectedProduct: ' + val.id)
        let item = this.getProductsSearchedByReference.find(x => x.id === val.id)
        if (item !== null && typeof item !== 'undefined') {
          this.getSelectedSupplierOfferPosition.product = item
        } else {
          this.getSelectedSupplierOfferPosition.product.reference = this.searchReference
        }
      },
      deep: true
    },
    selectedSupplierOffer: {
      handler (val) {
        console.log('selectedSupplierOffer: ' + JSON.stringify(val))
        if (typeof val !== 'undefined' && val != null) {
          if (!this.stepBackClicked) {
            this.step = 3
          }
          this.newSupplierOffer = val
        } else {
          this.step = 2
          this.newSupplierOffer = {
            documents_id: 0
          }
        }
        this.declineSupplierChecked = false
        this.newSupplierOfferDecline = this.newSupplierOfferDeclineTemplate
        if (this.isSupplierDeclined(this.selectedSupplier.id)) {
          this.setDeclinedSupplier(this.selectedSupplier.id)
          this.step = 2
        }

        if (val !== null) {
          this.loadSupplierOfferPositionBySupplierOfferAndInquiryPositionID(val.id)
        }
      },
      deep: true
    },
    getSupplierOfferPositionPrice: {
      handler (val) {
        let formatRemoved = val.replace(/\./g, '')
        formatRemoved = formatRemoved.replace(/,/g, '.')
        this.getSelectedSupplierOfferPosition.unit_price = formatRemoved

        this.calculateTotalSupplierOfferPositionPrice()
      }
    },
    getSelectedSupplierOfferPosition: {
      handler (val) {
        this.calculateTotalSupplierOfferPositionPrice()
      },
      deep: true
    },
    getSupplierDialogState: {
      handler (val) {
        if (val === false) {
          this.$store.dispatch(ContactPersonSettings.actions.loadContactPersonsBySupplierId, this.selectedSupplier.id)
        }
      },
      deep: true
    }

  },
  directives: {money: VMoney}
}
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

    .supplierWizard {
        height: 90vh;
        overflow: scroll;

    }

    .contactPerson {
        margin-top: -6px;
    }

    .layoutWrapHeight {
        height: auto;
    }

    @media (min-width: 960px) {
        .layoutWrapHeight {
            height: 55px;
        }

        .customerDesc {
            margin-top: -28px;
        }
    }

    @media (max-width: 960px) {

        .customerDesc {
            margin-top: 0;
        }
    }

    .listContainer {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
    }

</style>



// WEBPACK FOOTER //
// src/components/Distribution/SupplierOffer/SupplierOffersInquiryPositions.vue